import React, { useEffect, useState } from 'react'
import { Box, Grid, IconButton, ListItemIcon, MenuItem, Pagination, Stack, useTheme } from '@mui/material';
import ScrollBox from '../../../components/ScrollBox';
import { isNotEmpty } from '../../../utils/format';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BackButton from '../../../components/BackButton';
import route from '../../../utils/Routes';
import { getAmtcProd, getAmtcSubCat } from '../../../services/amtc-service';
import { useQuery } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { useAuthContext } from '../../../context/AuthContext';
import { customAlert } from '../../../components/notify';
import ProductCard from '../../../components/ProductCard';
import CatCard from '../../../components/CatCard';
import SearchTxtField from '../../../components/SearchTxtField';
import SwapVertOutlinedIcon from '@mui/icons-material/SwapVertOutlined';
import { Edit, MoreVert } from '@mui/icons-material';
import OptionMenu from '../../../components/OptionMenu';
import CreateNewFolderIcon from '@mui/icons-material/CreateNewFolder';
import PathBtns from '../../../components/PathBtns';
import constants from '../../../utils/Constants';

function AmtcSubCategoryPage() {
    const theme = useTheme();
    const navigate = useNavigate();
    const { setLoadingScreen, ctxtUser } = useAuthContext();
    const [searchParams, setSearchParams] = useSearchParams();
    const catId = parseInt(searchParams.get("catId"));
    const catName = searchParams.get("catName");

    const limit = 12;
    const prPageNumber = parseInt(searchParams.get("prPageNumber") || "1");
    const caPageNumber = parseInt(searchParams.get("caPageNumber") || "1");
    const querySearchWord = searchParams.get("s") || "";
    const isSrchRes = parseInt(searchParams.get("isSrchRes") || "0");
    const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
    const [isSrchBtnClick, setIsSrchBtnClick] = useState(0)
    const [caOrder, setCaOrder] = useState('desc');
    const { isLoading: isCatLoading, isError: isCatErr, error: catErr, data: catData } = useQuery([QueryKey.amtcSubCat, limit, caPageNumber, caOrder, catId],
        () => getAmtcSubCat({ catId, limit, pageNumber: caPageNumber, order: caOrder }), {
        enabled: isNotEmpty(catId),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    const { isLoading: isProdLoading, isError: isProdErr, error: prodErr, data: prodData } = useQuery([QueryKey.amtcProd, limit, prPageNumber, isSrchBtnClick],
        () => getAmtcProd({ limit, pageNumber: prPageNumber, searchKeyWord: searchWord }), {
        enabled: isSrchRes === 1,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const optionItems = [
        {
            title: "Edit Category",
            icon: <Edit fontSize="small" />,
            fn: () => navigate(route.aEditCat, { state: { catId, catName } })
        },
        {
            title: "Add Subcategory",
            icon: <CreateNewFolderIcon fontSize="small" />,
            fn: () => navigate(route.aCreateSubCat, { state: { catId, catName } })
        }
    ]
    const pathBtnsArr = [{
        label: "Category",
        handleClick: () => navigate(route.aCataLog)
    }, {
        label: catName,
        handleClick: () => navigate(`${route.aSubcategory}/?catId=${catId}&catName=${catName}`, { replace: true })
    }]

    // useEffect(() => {
    //     if (catData?.totalCatCount === 0) {
    //         navigate(`${route.aProducts}/?catId=${catId}`, { replace: true });
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [catData?.totalCatCount]);

    useEffect(() => {
        if (!catId) {
            navigate("/", { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [catId]);

    useEffect(() => {
        setLoadingScreen(isCatLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isCatLoading]);

    useEffect(() => {
        setLoadingScreen(isProdLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isProdLoading]);

    async function onOrderChange(e) {
        if (caOrder === "desc")
            setCaOrder("asc");
        else
            setCaOrder("desc");
        setSearchParams(prev => {
            prev.set("caPageNumber", 1)
            return prev
        }, { replace: true })
    }

    function handleSubCatCardClick(i) {
        navigate(`${route.aProducts}/?subCatId=${i?.id}`);
    }

    async function onSearchBtnClick(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchParams(prev => {
            prev.set("prPageNumber", 1)
            prev.set("caPageNumber", 1)
            prev.set("isSrchRes", 1)
            return prev
        }, { replace: true })
    }

    function handleOnClear(e) {
        setSearchWord("");
        setSearchParams(prev => {
            prev.set("prPageNumber", 1)
            prev.set("caPageNumber", 1)
            prev.set("s", "")
            prev.set("isSrchRes", 0)
            return prev
        }, { replace: true })
    }

    function onSearch(e) {
        setSearchWord(e.target.value)
        setSearchParams(prev => {
            prev.set("s", encodeURIComponent(e.target.value))
            return prev
        }, { replace: true })
    }

    // function handleDDChange(e) {
    //     setSearchParams(prev => {
    //         prev.set("st", e.target.value)
    //         return prev
    //     }, { replace: true })
    // }

    const handleOptionClose = () => {
        setAnchorEl(null);
    };

    const handleOptionClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePrPageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("prPageNumber", value)
            return prev
        }, { replace: true })
    };

    const handleCaPageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("caPageNumber", value)
            return prev
        }, { replace: true })
    };


    if (isCatErr) {
        customAlert(catErr);
        return <h2>Something went wrong</h2>
    }

    if (isProdErr) {
        customAlert(prodErr);
        return <h2>Something went wrong</h2>
    }

    return (
        <Box height={"100%"} width={"100%"}>

            <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1, mt: 1 }} width={"100%"}>
                <Stack width={"33%"} direction={"row"} alignItems={"center"} gap={1}>
                    <BackButton />
                    <PathBtns btnsArr={pathBtnsArr} />
                </Stack>
                <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2} width={"33%"} >
                    <Box mb={0.5}><SearchTxtField width={400} handleOnClear={handleOnClear} variant={"outlined"} searchKeyWord={searchWord}
                        onSearch={onSearch} onBtnClick={onSearchBtnClick} placeholder={ctxtUser?.isComUser ? `Search Product By Name / AMTC ID / MAT Code / Desc / Manufacturer` : `Search Product By Name / AMTC ID / Desc / Manufacturer`} /></Box>
                </Stack>
                <Stack direction={"row"} justifyContent="end" alignItems={"center"} gap={2} width={"33%"} >
                    {isSrchRes === 1 ? <></> : <IconButton onClick={onOrderChange}>
                        <SwapVertOutlinedIcon />
                    </IconButton>}
                    {ctxtUser?.userType === constants.admin && <IconButton onClick={handleOptionClick} sx={{ color: theme.palette.custom.btn }}  >
                        <MoreVert />
                    </IconButton>}
                </Stack>
            </Stack>

            {isSrchRes === 1 ? <><ScrollBox height={"84%"}>
                <Grid container spacing={3}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    {(prodData?.prodsArr ?? []).map((i) => <Grid item xs="auto" key={i.id}>
                        <ProductCard i={i} key={i?.id} isComUser={ctxtUser?.isComUser} /> </Grid>)}
                </Grid>
            </ScrollBox>
                <Stack sx={{ alignItems: "center", mt: 1 }}>
                    <Pagination count={Math.ceil(prodData?.totalProdsCount / limit) || 0} color="primary"
                        page={prPageNumber} onChange={handlePrPageChange} variant="outlined" shape="rounded" />
                </Stack>
            </> : <><ScrollBox height={"84%"}>
                <Grid container spacing={3}
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                >
                    {(catData?.subCatsArr ?? []).map((i) => <Grid item xs="auto" key={i.id}>
                        <CatCard i={i} key={i?.id} handleClick={handleSubCatCardClick} /> </Grid>)}
                </Grid>
            </ScrollBox>
                <Stack sx={{ alignItems: "center", mt: 1 }}>
                    <Pagination count={Math.ceil(catData?.totalCatCount / limit) || 0} color="primary" page={caPageNumber} onChange={handleCaPageChange} variant="outlined" shape="rounded" />
                </Stack>
            </>}
            <OptionMenu open={open} handleClose={handleOptionClose} anchorEl={anchorEl} >
                {optionItems.map((i) => <MenuItem
                    sx={{ pl: 2, pr: 5, fontSize: 14 }}
                    key={i.title}
                    onClick={i.fn}>
                    <ListItemIcon > {i.icon}</ListItemIcon>
                    {i.title}
                </MenuItem>)}
            </OptionMenu>
        </Box>
    )
}
export default AmtcSubCategoryPage;




